import filter from "@/api/filter";

//全部
export const allColumns = [
  {
    title: "保单号",
    slot: "policyNo",
    align: "center",
    width: 220,
  },
  {
    title: "产品名称",
    width: 250,
    key: "productName",
    align: "center",
  },
  {
    title: "投保人/手机号",
    width: 160,
    align: "center",
    render(h, params) {
      return <span>{params.row.holderName}/{params.row.holderMobile}</span>;
    }
  },
  {
    title: "保单状态",
    align: "center",
    minWidth: 100,
    render(h, params) {
      const payStatus = params.row.policyStatus;
      const result = filter.filterInsureOrderStatus(payStatus);
      return <span>{result}</span>;
    },
  },
  {
    title: "应续日/交费年数",
    width: 160,
    key: "needPayDateAndRenewalYears",
    align: "center",
  },
  {
    title: "交费方式/第几次交费",
    width: 180,
    key: "payTypeAndRenewalTimes",
    align: "center",
  },
  {
    title: "续费状态/更进状态",
    width: 180,
    key: "payAndServiceState",
    align: "center",
  },
  {
    title: "宽限期满日",
    width: 120,
    align: "center",
    render(h, params) {
      const lastPayDate = params.row.lastPayDate;
      const result = filter.filterTime(lastPayDate, 'YYYY-MM-DD');
      return <span>{result}</span>;
    },
  },
  {
    title: "应续保费/实收保费（元）",
    width: 200,
    align: "center",
    render(h, params) {
      return <span>{params.row.fee} / {params.row.payState!=2 && params.row.payFee==0?'-':params.row.payFee}</span>;
    }
  },
  {
    title: "续期继承比例",
    width: 120,
    key: "extendRate",
    align: "center",
    render(h, params) {
      if(params.row.extendRate){
        return <span>{params.row.extendRate}%</span>;
      }else{
        return <span>-</span>;
      }
    }
  },
  {
    title: "服务费（元）",
    width: 120,
    key: "commissionPrice",
    align: "center",
  },
  {
    title: "服务费归属业务员/机构",
    align: "center",
    minWidth: 200,
    render(h, params) {
      return <span>{params.row.salesmanName}/{params.row.orgName}</span>;
    }
  },
  {
    title: "操作",
    slot: "bar",
    align: "center",
    width: 80,
    fixed: "right",
  },
]


// 待续费
export const renewalFeeColumns = [
  {
    title: "保单号",
    slot: "policyNo",
    align: "center",
    width: 220,
    ellipsis: true,
    tooltip: true,
  },
  {
    title: "应续日/交费年数",
    width: 160,
    key: "needPayDateAndRenewalYears",
    align: "center",
    ellipsis: true,
    tooltip: true,
  },
  {
    title: "交费方式/第几次交费",
    width: 180,
    key: "payTypeAndRenewalTimes",
    align: "center",
    ellipsis: true,
    tooltip: true,
  },
  {
    title: "宽限期满日",
    width: 300,
    align: "center",
    ellipsis: true,
    tooltip: true,
    slot:'slotColumn',
  },
  {
    title: "产品名称",
    width: 250,
    key: "productName",
    align: "center",
  },
  {
    title: "投保人/手机号",
    width: 160,
    align: "center",
    ellipsis: true,
    tooltip: true,
    render(h, params) {
      return <span>{params.row.holderName}/{params.row.holderMobile}</span>;
    }
  },
  {
    title: "保单状态",
    align: "center",
    minWidth: 100,
    tooltip: true,
    render(h, params) {
      const payStatus = params.row.policyStatus;
      const result = filter.filterInsureOrderStatus(payStatus);
      return <span>{result}</span>;
    },
  },
  {
    title: "更进状态",
    width: 100,
    key: "",
    align: "center",
    ellipsis: true,
    tooltip: true,
    render(h, params) {
      let value = '';
      const serviceState = params.row.serviceState;
      if (serviceState == 1) {
        value = '待跟进'
      } else if (serviceState == 2) {
        value = '跟进中'
      } else if (serviceState == 3) {
        value = '跟进完成'
      }
      return <span>{value}</span>;
    },
  },
  {
    title: "应续保费（元）",
    width: 130,
    key: "fee",
    align: "center",
    ellipsis: true,
    tooltip: true
  },
  {
    title: "失败原因",
    width: 150,
    key: "payFailTypeDesc",
    align: "center",
    render(h, params) {
      const value = params.row.payFailTypeDesc||'-';
      return <span>{value}</span>;
    },
  },
  {
    title: "续期继承比例",
    width: 120,
    key: "extendRate",
    align: "center",
    render(h, params) {
      if(params.row.extendRate){
        return <span>{params.row.extendRate}%</span>;
      }else{
        return <span>-</span>;
      }
    }
  },
  {
    title: "服务费（元）",
    width: 120,
    key: "commissionPrice",
    align: "center",
    ellipsis: true,
    tooltip: true,
  },
  {
    title: "服务费归属业务员/机构",
    align: "center",
    minWidth: 200,
    tooltip: true,
    render(h, params) {
      return <span>{params.row.salesmanName}/{params.row.orgName}</span>;
    }
  },
  {
    title: "机构/业务员",
    align: "center",
    minWidth: 200,
    tooltip: true,
    render(h, params) {
      return <span>{params.row.orgName}/{params.row.salesmanName}</span>;
    }
  },
  {
    title: "操作",
    slot: "bar",
    align: "center",
    width: 80,
    fixed: "right",
  }
]


// 已续费
export const renewedColumns = [
  {
    title: "保单号",
    slot: "policyNo",
    align: "center",
    width: 220,
    ellipsis: true,
    tooltip: true,
  },
  {
    title: "产品名称",
    width: 250,
    key: "productName",
    align: "center",
  },
  {
    title: "投保人/手机号",
    width: 160,
    align: "center",
    ellipsis: true,
    tooltip: true,
    render(h, params) {
      return <span>{params.row.holderName}/{params.row.holderMobile}</span>;
    }
  },
  {
    title: "保单状态",
    key: "status",
    align: "center",
    minWidth: 120,
    tooltip: true,
    render(h, params) {
      const payStatus = params.row.policyStatus;
      const result = filter.filterInsureOrderStatus(payStatus);
      return <span>{result}</span>;
    },
  },
  {
    title: "应续日/交费期数",
    width: 160,
    key: "needPayDateAndRenewalYears",
    align: "center",
    ellipsis: true,
    tooltip: true,
  },
  {
    title: "交费方式/第几次交费",
    width: 180,
    key: "payTypeAndRenewalTimes",
    align: "center",
    ellipsis: true,
    tooltip: true,
  },
  {
    title: "应续保费/实收保费（元）",
    width: 200,
    align: "center",
    ellipsis: true,
    tooltip: true,
    render(h, params) {
      return <span>{params.row.fee} / {params.row.payFee?params.row.payFee:'-'}</span>;
    }
  },
  {
    title: "续期继承比例",
    width: 120,
    key: "extendRate",
    align: "center",
    render(h, params) {
      if(params.row.extendRate){
        return <span>{params.row.extendRate}%</span>;
      }else{
        return <span>-</span>;
      }
    }
  },
  {
    title: "服务费（元）",
    width: 120,
    key: "commissionPrice",
    align: "center",
    ellipsis: true,
    tooltip: true,
  },
  {
    title: "实际缴费日",
    width: 120,
    align: "center",
    ellipsis: true,
    tooltip: true,
    render(h, params) {
      const serverEndDate = params.row.serverEndDate;
      const result = filter.filterTime(serverEndDate, 'YYYY-MM-DD');
      return <span>{result}</span>;
    },
  },
  {
    title: "服务费归属业务员/机构",
    align: "center",
    minWidth: 200,
    tooltip: true,
    render(h, params) {
      return <span>{params.row.salesmanName}/{params.row.orgName}</span>;
    }
  },
  {
    title: "操作",
    slot: "bar",
    align: "center",
    width: 80,
    fixed: "right",
  }
]


// 续费失败，已过宽限期
export const otherColumns = [
  {
    title: "保单号",
    slot: "policyNo",
    align: "center",
    width: 220,
    ellipsis: true,
    tooltip: true,
  },
  {
    title: "产品名称",
    width: 250,
    key: "productName",
    align: "center",
  },
  {
    title: "投保人/手机号",
    width: 160,
    align: "center",
    ellipsis: true,
    tooltip: true,
    render(h, params) {
      return <span>{params.row.holderName}/{params.row.holderMobile}</span>;
    }
  },
  {
    title: "保单状态",
    key: "status",
    align: "center",
    minWidth: 100,
    tooltip: true,
    render(h, params) {
      const payStatus = params.row.policyStatus;
      const result = filter.filterInsureOrderStatus(payStatus);
      return <span>{result}</span>;
    },
  },
  {
    title: "应续日/交费期数",
    width: 160,
    key: "needPayDateAndRenewalYears",
    align: "center",
    ellipsis: true,
    tooltip: true,
  },
  {
    title: "交费方式/第几次交费",
    width: 180,
    key: "payTypeAndRenewalTimes",
    align: "center",
    ellipsis: true,
    tooltip: true,
  },
  {
    title: "宽限期满日",
    width: 300,
    align: "center",
    ellipsis: true,
    tooltip: true,
    render(h, params) {
      const lastPayDate = params.row.lastPayDate;
      const result = filter.filterTime(lastPayDate, 'YYYY-MM-DD');
      return <span>{result}</span>;
    },
  },
  {
    title: "应续保费（元）",
    width: 130,
    key: "fee",
    align: "center",
    ellipsis: true,
    tooltip: true,
  },
  {
    title: "续期继承比例",
    width: 120,
    key: "extendRate",
    align: "center",
    render(h, params) {
      if(params.row.extendRate){
        return <span>{params.row.extendRate}%</span>;
      }else{
        return <span>-</span>;
      }
    }
  },
  {
    title: "失败原因",
    width: 120,
    align: "center",
    ellipsis: true,
    tooltip: true,
    render(h, params) {
      let value = '';
      const payFailType = params.row.payFailType;
      if(payFailType == 1){
        value = '豁免保费'
      }else if(payFailType == 2) {
        value = '已终止'
      }else if(payFailType == 3) {
        value = '已过宽限期'
      }else if(payFailType == 4) {
        value = '健康原因'
      }else if(payFailType == 5) {
        value = '产品原因'
      }else if(payFailType == 6) {
        value = '经济原因'
      }else if(payFailType == 7) {
        value = '已退保'
      }else if(payFailType == 8){
        value = '其他'
      }else{
        value = '-'
      }
      return <span>{value}</span>;
    },
  },
  {
    title: "服务费归属业务员/机构",
    align: "center",
    minWidth: 200,
    tooltip: true,
    render(h, params) {
      return <span>{params.row.salesmanName}/{params.row.orgName}</span>;
    }
  },
  {
    title: "操作",
    slot: "bar",
    align: "center",
    width: 80,
    fixed: "right",
  }
]




